/** Demo floors shipped with architectural plans. */
export const DEMO_FLOOR_ID = 'f0000000-0000-0000-0000-000000000001'
export const DEMO_FLOOR_BG_PATH = '/floor-plans/building-a-level-2.png'
export const DEMO_FLOOR_OFFICE_ID = 'f0000000-0000-0000-0000-000000000002'
export const DEMO_FLOOR_OFFICE_BG_PATH = '/floor-plans/building-a-level-2-v2.png'

export function resolveFloorBackgroundUrl(src: string): string {
  if (!src) return ''
  if (src.startsWith('data:') || src.startsWith('http://') || src.startsWith('https://')) return src
  const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
  const path = src.startsWith('/') ? src : `/${src}`
  return `${publicUrl}${path}`
}
